import * as React from 'react';
import { IChannel } from '../../../../data/api/models';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface IFooterProps {
  channel: IChannel;
}

export default class Footer extends React.Component<IFooterProps, any> {
  private renderFooterBg = () => {
    return (
      <div className="bg-container footer">
        <img src={require('./img/rcp_footer_bg.png')} alt=""/>
      </div>
    );
  }

  public render() {
    // const { channel } = this.props;

    return (
      <footer className="footer">
        <div className="container footer-top-container">
          <Row>
            <Col md={12}>
              <a href="https://www.msamlin.com/en/markets/France.html" target="_blank">
                <img className="msamlin-logo pull-right" src={require('./img/msamlin_logo.svg')} alt=""/>
              </a>
            </Col>
          </Row>
        </div>
        <div className="footer-container">
          <div className="footer-content">
            <div className="container">
              <Row>
                <Col md={12}>
                  <div className="main-footer-links">
                    {this.props.channel.live && (
                      <ul>
                        <li>
                          <Link to="/legal-notice">
                            Mentions légales et CGU
                          </Link>
                        </li>
                        <li>
                          <Link to="/contacts">
                            Contacts
                          </Link>
                        </li>
                      </ul>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <img src={require('./img/rcp_footer_bg.png')} alt=""/>
        </div>
        {/*{this.renderFooterBg()}*/}
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Footer/index.tsx